/**
 * コントロールパネル - 実行・クリアボタンなど
 */
export class ControlPanel {
  private container: HTMLElement;
  private runButton!: HTMLButtonElement;
  private clearButton!: HTMLButtonElement;
  private isRunning = false;

  private onRunCallback?: () => void;
  private onClearCallback?: () => void;

  constructor(parentElement: HTMLElement) {
    this.container = document.createElement("div");
    this.container.className = "control-panel";
    parentElement.appendChild(this.container);

    this.render();
  }

  /**
   * 実行ボタンクリック時のコールバック
   */
  onRun(callback: () => void): void {
    this.onRunCallback = callback;
  }

  /**
   * クリアボタンクリック時のコールバック
   */
  onClear(callback: () => void): void {
    this.onClearCallback = callback;
  }

  /**
   * 実行中状態を設定
   */
  setRunning(running: boolean): void {
    this.isRunning = running;
    this.runButton.disabled = running;
    this.runButton.textContent = running ? "実行中..." : "実行";
    this.clearButton.disabled = running;
  }

  /**
   * UIを描画
   */
  private render(): void {
    this.runButton = document.createElement("button");
    this.runButton.className = "control-button control-button--run";
    this.runButton.textContent = "実行";
    this.runButton.setAttribute("aria-label", "プログラムを実行");
    this.runButton.addEventListener("click", () => {
      if (this.onRunCallback && !this.isRunning) {
        this.onRunCallback();
      }
    });

    this.clearButton = document.createElement("button");
    this.clearButton.className = "control-button control-button--clear";
    this.clearButton.textContent = "クリア";
    this.clearButton.setAttribute("aria-label", "プログラムをクリア");
    this.clearButton.addEventListener("click", () => {
      if (this.onClearCallback && !this.isRunning) {
        this.onClearCallback();
      }
    });

    this.container.appendChild(this.runButton);
    this.container.appendChild(this.clearButton);
  }
}
